import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-sim-change-error',
  templateUrl: './sim-change-error.component.html',
  styleUrls: ['./sim-change-error.component.scss']
})
export class SimChangeErrorComponent implements OnInit {
  title: string;
  message: string;
  authoringContentData: any;
  showBtn:boolean = true;
  footerBtnTxt: string;
  constructor(private modalService: NgbModal,public utilsSvc: UtilsService) { }

  ngOnInit(): void {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
  }
  close(){
    this.modalService.dismissAll();
  }

}
